import clsx from 'clsx'
import React from 'react'
import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import { A11y, FreeMode, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { useProductServices } from '@/features/product-services/hooks/useProductServices'
import { TServiceVariant } from '@/features/product-services/lib/types'
import { ProductServiceCard } from '@/features/product-services/ui/ProductServiceCard/ProductServiceCard'

import { SliderNextButton, SliderPrevButton } from '@/shared/ui/SliderButtons'

import cl from './ProductServices_Slider.module.scss'

export type ServicesConfigurator_ProductProps = {
	rows: TServiceVariant[]
	relatedId: number
	activeServices?: string[]
}

const APPLE_CARE_ID = `15873`

const BREAKPOINTS = {
	640: {
		slidesPerView: 1.5,
		spaceBetween: 10
	},
	768: {
		slidesPerView: 2.2,
		spaceBetween: 10
	},
	1024: {
		slidesPerView: 3.2,
		spaceBetween: 10
	},
	1480: {
		slidesPerView: 4,
		spaceBetween: 10
	}
}

export const ProductServices_Slider = ({ rows, relatedId }: ServicesConfigurator_ProductProps): JSX.Element => {
	const { countChangeHandler, activityChangeHandler, hasActiveService, activeServiceId } = useProductServices(
		rows,
		relatedId
	)

	return (
		<div>
			<Swiper
				slidesPerView={1.3}
				spaceBetween={10}
				freeMode={true}
				modules={[FreeMode, A11y, Navigation]}
				className={cl.swiperServices}
				watchOverflow={true}
				navigation={{
					prevEl: `.${cl.buttons__prevButton}`,
					nextEl: `.${cl.buttons__nextButton}`
				}}
				breakpoints={BREAKPOINTS}>
				{rows.map(row => {
					return (
						<SwiperSlide key={row.ID} className={clsx(cl.slide)}>
							<ProductServiceCard
								{...row}
								key={row.ID}
								ID={row.ID}
								onCountChange={newCount => countChangeHandler(newCount, row)}
								onActivityChange={(isActive: boolean) => activityChangeHandler(isActive, row)}
								borderBottom={row.ID === APPLE_CARE_ID}
								count={1}
								price={row.PRICE}
								isActive={row.ID === activeServiceId}
								bonusScore={0}
								maxCount={1}
								hasActiveService={hasActiveService}
							/>
						</SwiperSlide>
					)
				})}
				<div className={cl.buttons}>
					<SliderPrevButton className={cl.buttons__prevButton} />
					<SliderNextButton className={cl.buttons__nextButton} />
				</div>
			</Swiper>
		</div>
	)
}
